import apis from "../../core/apis.js";

class CreditsResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.credits).get(options);
  }

  get(id) {
    return this.$resource(apis.credits + id).get();
  }

  search(query = "") {
    return this.$resource(apis.credits + "autocomplete/").get({ query });
  }

  post(item) {
    return this.$resource(apis.credits).save(item);
  }

  update(id, item) {
    return this.$resource(apis.credits + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }
}

export default CreditsResource;



// WEBPACK FOOTER //
// ./src/resources/credits/credits.resource.js